/** The Lancer (docs/spec/04 §1): white hull, red trim, blue canopy. Drawn as its left half. */

import { BLUE, RED, SKY, WHITE } from '../palette';
import type { SpriteDef } from './types';
import { mirror, recolour } from './types';

const LANCER_HALF = [
  '.......W',
  '.......W',
  '.......W',
  '......WW',
  '......WW',
  '...R..WW',
  '...R.WWB',
  '...W.WBB',
  'R..WWWBB',
  'R..WWWWW',
  'W.WWWWWW',
  'WWWWWRWW',
  'WWWW.RWW',
  'WWW..RRW',
  'WW...R.W',
  'W.......',
];

export const LANCER: SpriteDef = {
  frames: [mirror(LANCER_HALF)],
  colours: { W: WHITE, R: RED, B: SKY },
  rotates: true,
};

/** The captive: the same ship in the hive's colours. */
export const CAPTIVE: SpriteDef = recolour(LANCER, { W: RED, R: WHITE, B: BLUE });
